module.exports = __webpack_public_path__ + "_app/img/google.0ab4444a.svg";